<!-- 计划节点 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
          <drag-dialog
            append-to-body
            :show.sync="dialogVisible"
            title="项目节点"
            :enableDrag="true"
            width="600px"
            @close="cancel"
          >
            <dynamic-form
              :formConfig="formConfig"
              v-model="form"
              labelWidth="130px"
              :look="openLook"
              @submit="submit"
              @cancelForm="cancel"
              :disabled="openLook"
              ref="pageForm"
            ></dynamic-form>
          </drag-dialog>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
        <template v-slot:whetherMilepostNode="scope">
          <span>{{ scope.row.whetherMilepostNode?'是':'否' }}</span>
          </template>
          <template v-slot:whetherFocusNode="scope">
             <span>{{ scope.row.whetherFocusNode?'是':'否' }}</span>
          </template>
          <template v-slot:whetherCheckNode="scope">
             <span>{{ scope.row.whetherCheckNode?'是':'否' }}</span>
          </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";
import {
  addProjectNode,
  deleteProjectNode,
  editProjectNode
} from "@/api/project-node";

export default {
  name: "Demo",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
    DynamicSearch,
    DragDialog
  },
  data() {
    return {
      delLoading: false,
      openLook: false,
      form: {},
      dialogVisible: false,
      formConfig: {
        formItemList: [
          {
            type: "text",
            showWordLimit: true,
            maxlength: "50",
            key: "code",
            label: "项目节点代码",
            value: "",
              rules: [
              { required: true, message: "项目节点代码不能为空", trigger: "blur" },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "项目节点代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "text",
            showWordLimit: true,
            maxlength: "100",
            key: "name",
            label: "项目节点名称",
            value: "",
            rules: [{
                required: true,
                message: "项目节点名称不能为空",
                trigger: "blur"
              }]
          },
          {
            label: "是否里程碑节点",
            key: "whetherMilepostNode",
            type: "switch",
            value: false,
            span: 8
          },
           {
            label: "是否重点关注节点",
            key: "whetherFocusNode",
            type: "switch",
            value: false,
             span: 8
          },
           {
            label: "是否考核节点",
            key: "whetherCheckNode",
            type: "switch",
            value: false,
             span: 8
          },
          {
            type: "textarea",
            showWordLimit: true,
            maxlength: "200",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: "code",
          label: "项目节点代码",
        },
        {
          prop: "name",
          label: "项目节点名称",
          query: {
            type: "input"
          }
        },
        {
          prop: "whetherMilepostNode",
          label: "是否里程碑节点",
          slot: "whetherMilepostNode"
        },
        {
          prop: "whetherFocusNode",
          label: "是否重点关注节点",
          slot: "whetherFocusNode"
        },
        {
          prop: "whetherCheckNode",
          label: "是否考核节点",
          slot: "whetherCheckNode"
        },
        {
          prop: "remark",
          label: "备注",
        }
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    editActiveEvent(row, column) {
      console.log(row, column);
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/bsProjectNode`;
      const params = {
        size: this.offset,
        page: this.page
      };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 打开新增弹框
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
    // 删除
    del(row) {
      this.delLoading = true;
      deleteProjectNode(row.id).then(() => {
        this.$notify({ title: "删除成功！", type: "success", duration: 2500 });
        this.dataTableInit();
        this.delLoading = false;
      }).catch(() => {
          this.delLoading = false;
        });
    },
    // 打开修改弹框
    edit(row) {
      console.log(row)
      this.form = row;
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    // 提交 （添加/修改）
    submit() {
      if (this.form.id) {
        editProjectNode(this.form).then(res => {
          this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      } else {
        addProjectNode(this.form).then(res => {
        this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>